import { render, staticRenderFns } from "./PolicyPrivacy.vue?vue&type=template&id=2a89024d&scoped=true"
import script from "./PolicyPrivacy.vue?vue&type=script&lang=js"
export * from "./PolicyPrivacy.vue?vue&type=script&lang=js"
import style0 from "./PolicyPrivacy.vue?vue&type=style&index=0&id=2a89024d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89024d",
  null
  
)

export default component.exports